import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n/i18n";
import { Root } from "./Root";
import reportWebVitals from "./reportWebVitals";
import {
  BrandVariants,
  createDarkTheme,
  createLightTheme,
  FluentProvider,
  Theme,
} from "@fluentui/react-components";
import { t } from "i18next";

const hisselektronik: BrandVariants = {
  10: "#020304",
  20: "#13171C",
  30: "#1D2630",
  40: "#263240",
  50: "#2E3F51",
  60: "#364C63",
  70: "#3E5975",
  80: "#476788",
  90: "#50759B",
  100: "#5983AE",
  110: "#6292C3",
  120: "#72A0D0",
  130: "#89AED7",
  140: "#9FBCDF",
  150: "#B4CBE6",
  160: "#C9D9ED",
};

const selectedTheme = hisselektronik;
const lightTheme: Theme = {
  ...createLightTheme(selectedTheme),
  ...{
    colorBrandBackground: "#6699CC",
    colorCompoundBrandStroke: "#0F6CBD",
    colorBrandStroke1: "0F6CBD",
  },
};

const darkTheme: Theme = {
  ...createDarkTheme(selectedTheme),
};

darkTheme.colorBrandForeground1 = selectedTheme[110];
darkTheme.colorBrandForeground2 = selectedTheme[120];

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const setFavicon = () => {
  const favicon = document.getElementById("favicon") as HTMLLinkElement;
  if (favicon) {
    favicon.href = "/favicon/hisselektronik-favicon.png";
  }
};
const setTitle = () => {
  document.title = t("texts.customerPortalHisselektronik");
};

setFavicon();
setTitle();
root.render(
  <React.StrictMode>
    <FluentProvider theme={lightTheme}>
      <Root />
    </FluentProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
